<template>
	<div class="answer-val answer-match-item position-rel">
	    <b class="display-block" style="margin-right: 5px;" v-if="dataSource.code" :class="{'float-left': !dataSource.imageUrl}">{{ `${dataSource.code} . ` }}</b> 
	    <div 
	    	class="answer__img__sentence text-center display-inline-block" 
	    	v-if="dataSource.imageUrl" 
	    	:style="`width: ${parent.imageWidth}px; max-height: ${parent.imageHeight}px`"
	    	:class="`size-${parent.imageWidth}-${parent.imageHeight}`"
	    >
				<img 
					:src="`${urlQuestionImg}/${dataSource.imageUrl}`" 
					alt="Ảnh câu trả lời" 
					class="answer__img"
				/>
	    	<span class="display-block" v-html="dataSource.content"></span>
		</div>
		<span v-else v-html="dataSource.content"></span>
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'
	import { APP_CONFIG } from '@/utils/constants'

	export default {

		name: 'MathCol',
		mixins: [ mixinsQuestionPreview ],
		data () {
			return {
				urlQuestionImg: APP_CONFIG.urlQuestionImg
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>